module.exports = __webpack_public_path__ + "images/bannerFR-23a29c03de998da9cdb47af05e4433af.png";